
<template>
  <div class="fade-in">
    <div class="chat-container">
      <div class="chat-grid-container">
        <div class="chat-sidebar">
          <div class="container__selected phone__company btn-align">
            <CompanyPhone @phone-number-selected="onSelectAccountPhoneNumber" />
            <div class="row col-6">
              <ButtonRefresh
                :dadosFiltradosCompanyPhone="chatTalksFilter"
                :loading="loadingChatAll"
                @filter-button="onSelectAccountPhoneNumber"
              />
              <FilterMessages
                :dadosFiltradosCompanyPhone="chatTalksFilter"
                @filter-button="onSelectAccountPhoneNumber"
              />
            </div>
          </div>
          <div v-if="telefoneIdSelected" class="mr-2 ml-2 mt-2">
            <div class="input-group mb-1">
              <!-- <input
                v-model="newPhone"
                type="number"
                class="form-control"
                :placeholder="getPlaceHolderNewPhone()"
                :title="$t('sectionConversas.conversasInformeNumeroTel')"
                aria-label="Recipient's username"
                aria-describedby="button-addon2"
              /> -->
              <v-select
                v-model="newPhone"
                style=" background-color: white; color: black;"
                :placeholder="$t('sectionModalNewBudget.searchPhoneOrName')"
                :options="vSelectContato"
                :multiple="false"
                @search="ObterContato"
                class="flex-grow-1"
                @input="handleSelectItem"
              >
                <template slot="no-options">
                  {{ $t("textNenhumResultado") }}
                </template>
              </v-select>
            </div>
          </div>
          <div v-if="telefoneIdSelected">
            <small class="mr-2 ml-2">
              {{ chatTalksFiltered.newCalls.total }}
              {{ $t("sectionConversas.conversasContatoCom") }}
            </small>
          </div>
          <div class="section-aba">
            <div
              class="aba-left"
              :class="{active_aba: flagaba === 1}"
              @click="funcAba2(1)"
            >
              Novos
              <span class="contagem">{{
                chatTalksFiltered.newCalls.total < 99
                  ? chatTalksFiltered.newCalls.total
                  : "+99"
              }}</span>
            </div>
            <div
              class="aba-center"
              :class="{active_aba: flagaba === 2}"
              @click="funcAba2(2)"
            >
              Andamento
              <span class="contagem">{{
                chatTalksFiltered.inAttendance.total < 99
                  ? chatTalksFiltered.inAttendance.total
                  : "+99"
              }}</span>
            </div>
            <div
              class="aba-right"
              :class="{active_aba: flagaba === 3}"
              @click="funcAba2(3)"
            >
              Concluído
              <!-- <span class="contagem">50</span> -->
            </div>
          </div>
          <div
            id="ChatTalksContainer"
            class="chat-sidebar-talks-container"
            @scroll="onScrollChatTalksContainer"
          >
            <div
              v-if="pagingTalks.loading"
              class="chat-sidebar-empty-description"
            >
              <div class="mt-auto mb-auto text-center">
                <div class="mb-4">
                  {{ $t("sectionConversas.conversasCarregandoConversas") }}
                </div>
                <i class="fas fa-spinner fa-spin fa-2x"></i>
              </div>
            </div>
            <div
              v-for="(item, index) in chats"
              :key="index"
              class="border-wrapper"
              :title="$t('sectionConversas.textVisualizarOpcoes')"
            >
              <div
                class="chat-sidebar-item"
                :class="[
                  talkSelected.contatoId == item.contatoId
                    ? 'chat-sidebar-item--active'
                    : '',
                    item.prazoRespostaExpirado ?'chat-sidebar-item--vencido':''
                ]"
                @click="onClickConversation(item)"
              >
                <ProfilePicture 
                v-if="item.urlPerfil != 'x' "  
                :profilePicturePath="item.urlPerfil"
                :tipoConversa="item.enumTipoContato" /> 
           
                <ProfilePicture v-else-if="item.urlPerfil == 'x'" :customerName="item.nome" :tipoConversa="item.enumTipoContato"/> 
                
                <div id="conversation" class="conversation-container">
                  <div name="nome" class="chat-sidebar-item-title">
                    {{ item.nome }}
                  </div>
                  <small name="numero" class="sidebar-item--number">
                    {{
                      !item.isGrupo
                        ? item.numero
                        : $t("sectionParametro.parametroGrupo")
                    }}
                  </small>
                  <small
                    v-if="item.dataUltimoProcessamento"
                    class="sidebar-item--number"
                    :title="$t('dateTimeLastMessage')"
                  >
                    - {{ getDateFormat(item.dataUltimoProcessamento) }}
                  </small>
                  <div class="align_item_atendimento">
                    <div>
                      <small
                        v-if="item.atendimento"
                        class="sbadge sbadge--New_info sbadge-custom"
                      >
                        {{
                          getUserAttendance(item.atendimento).substring(0, 32)
                        }}
                      </small>
                    </div>
                    <div class="item_atendimento"></div>
                  </div>
                  <div
                    v-if="item.etapas && item.etapas.length > 0"
                    class="scircle-tags-container"
                    :title="getTitleEtapas(item.etapas)"
                  >
                    <span
                      v-for="(item, index) in item.etapas"
                      :key="index"
                      class="scircle tags-margin--1"
                      :style="'background-color: ' + item.cor"
                    >
                    </span>
                  </div>
                </div>
                <div class="ml-auto">
                  <span
                    v-if="item.badge"
                    class="badge badge-success m-1"
                    :title="$t('sectionConversas.conversasContatoNovaMensagem')"
                  >
                    <i class="fas fa-exclamation"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="pt-3"></div>
          <!-- finalizador totalizador -->
          <!-- <div class="pl-1"> contabilizador de total
            {{ $t("sectionConversas.conversasTotalConversas") }}
            {{
              this.chatTalksFiltered.inAttendance.total +
              this.chatTalksFiltered.newCalls.total +
              this.chatTalksFiltered.callsCompleted.total
            }}
          </div> -->
        </div>
        <div class="Column-direction">
          <div
            v-if="getChatReady() && !talkSelected.isGrupo"
            class="chat-header"
          >
            <div class="chat-header--left">
              <TalkHeader :attendance="getCurrentTalkAttendance()" />
              <div class="ml-3">
                <TagsContainer :etapas="getEtapas()" />
              </div>
            </div>
            <div class="chat-header--margin ml-2">
              <div :title="$t('sectionConversas.textVisualizarOpcoes')">
                <b-form-checkbox v-model="showInternalMessage" switch>
                  {{ $t("sectionConversas.conversasInterna") }}
                </b-form-checkbox>
              </div>
              <div :title="$t('sectionConversas.textVisualizarOpcoes')">
                <b-form-checkbox v-model="showLogMessage" switch>
                  Log
                </b-form-checkbox>
              </div>
            </div>
            <div class="chat-header--margin ml-2">
              <ModalTag
                :contato="talkSelected"
                evento="updateEtapas"
                @updateEtapas="updateEtapas"
              />
            </div>
            <div class="chat-header--margin ml-2">
              <ModalSearch
                :contato-id="talkSelected.contatoId"
                :telefone-id="telefoneIdSelected"
                :tipoConversa="talkSelected.enumTipoContato"
                :enumTipoContato = "talkSelected.enumTipoContato"
              />
            </div>
            <div class="chat-header--margin ml-2">
              <ModalBudget :contato-id="talkSelected.contatoId" />
            </div>
            <div class="chat-header--margin ml-2">
              <ModalArchive
                :contato-id="talkSelected.contatoId"
                :telefoneId="telefoneIdSelected"
                :enumTipoContato = "talkSelected.enumTipoContato"
              />
            </div>
            <div class="chat-header--margin ml-2 size-sm">
              <ModalPerson
                :contato-id="talkSelected.contatoId"
                :nome="talkSelected.nome"
                :numero="talkSelected.numero"
                :urlPerfil = "talkSelected.urlPerfil"
                :enumTipoContato = "talkSelected.enumTipoContato"
                evento="updateTalkSelected"
                @updateTalkSelected="updateTalkSelected"
              />
            </div>
          </div>
          <div v-else class="chat-header">
            <div class="ml-auto mt-1 mr-4">
              <div class="text-muted">
                <h5>{{ talkSelected.nome }}</h5>
              </div>
            </div>
          </div>

          <div v-if="!telefoneIdSelected" class="chat-not-initialized fade-in">
            <h2>
              {{ $t("sectionConversas.conversasSelecioneUmTelefone") }}
            </h2>
            <i class="fas fa-mobile-alt chat-icon" aria-hidden="true" />
          </div>

          <div
            v-if="telefoneIdSelected && !talkSelected.contatoId"
            class="chat-not-initialized fade-in"
          >
            <h2>
              {{ $t("sectionConversas.conversasSelecioneParaVisualizar") }}
            </h2>
            <i class="far fa-comment-dots chat-icon" aria-hidden="true"></i>
          </div>

          <div
            v-if="getChatReady()"
            id="ChatListContainer"
            class="chat-messages-container"
            @scroll="onScrollChatListContainer"
          >
            <ul class="chat-messages-list">
              <li v-for="(item, index) in messages" :key="index">
                <input type="hidden" :value="item.id" />
                <MessageContainer>
                  <template v-slot:messageDetail>
                    <MessageDetail
                      :ownerName="item.nome"
                      :date="item.data"
                      :origin="item.origem"
                      :type="item.tipo"
                      :scheduled="item.isAgendado"
                      :editada="item.isEditado"
                      :deleted="item.excluido"
                    ></MessageDetail>
                  </template>
                  <template v-slot:message>
                    <Message :id="'message' + index" :message="item" @replyMessageAction="replyMessage"/>
                  </template>
                </MessageContainer>
              </li>
            </ul>
          </div>
          <div v-show="getChatReady()" class="chat-footer">           
            <IniciarAtendimento
            v-if="
                this.$store.getters.getAutenticacao.isAtendente === true &&
                startAttendenceButtonVisibility
                "
              :contatoId="getContatoBudget()"
              :atendimentoId="getAttendanceBudget()"
              :tipo="getTipoAttendance()"
              :telefoneId="telefoneIdSelected"
              :enumTipoContato = "talkSelected.enumTipoContato"
              @disableButton="hideAttendenceButton2()"
              /> 
              <template>
            
                <div class="thumbnails-container">
                  <div class="thumbnail-container" v-for="(thumbnail, index) in thumbnailUrls" :key="index">
                    <img :src="thumbnail.url" class="thumbnail" v-if="thumbnail.fileType.indexOf('image') !== -1" />
                    <img src="~@/assets/img/documentoIcone.png" class="thumbnail-icon" v-else />
                    <button class="remove-thumbnail-button" @click="removeThumbnail(index)">
                      X
                    </button>
                  </div>
                </div>
            </template>
              <DefaultMessageBoxComand
                      :talk-selected="talkSelected"
                      :showContent="mostrarConteudo"
                      :selectedMessageIndex="MessageIndex"
                      :pesquisar="pesquisarMessageBoxComand"
                      @onClickMessage="onClickDefalutMessage"
                      @update:showContent="showContent = $event"
                    />
            <div class='respondendoMsg' v-if="mensagemResponder">
              <h6>{{ $t("textRespondendoMensagem") }}</h6>
              <span >
                {{ mensagemResponder.corpo }}
              </span>
              <button class="remove-respondendoMsg-button" @click="removeMsgResponder()">
                      X
              </button>
            </div>
              
            <div class="message-text-area-container">   
                <textarea
                v-if="this.$store.getters.getAutenticacao.isAtendente === true"
                id="TextAreaMessage"
                ref="textAreaMessageElement"
                v-model="message.corpo"
                rows="1"
                cols="50"
                class="message-text-area"
                :class="getMessageTextAreaClass()"
                :disabled="footerDisabledActions || !podeMandarMsg "
                @keypress="onKeyUpTextAreaMessage"
                @paste="onPaste"
                @input="onInputTextAreaMessage"
                @keydown="onKeyDownTextAreaMessage"
                />
                <div v-if="!podeMandarMsg" class="aviso">
                  <ModeloMensagemBox
                  v-if="numeroOficial"
                  :contato-id="talkSelected.contatoId"
                  :telefoneId="telefoneIdSelected"
                  :primeiraMensagem=true
                  @send-modelo="sendModeloMensagem"
                  />
                  <span v-else>{{ $t("sectionConversas.aviso24horas") }}</span>
                </div>
              <div
                v-if="!footerDisabledActions"
                v-show=" this.$store.getters.getAutenticacao.isAtendente === true && podeMandarMsg"
                class="message-text-area-buttons-container"
                >
                <b-form-checkbox
                  v-model="internalMessage"
                  class="ml-1 mr-auto"
                  name="check-button"
                  size="sm"
                  switch
                >
                  {{ $t("sectionConversas.conversasMensagemInterna") }}
                  <div
                    v-show="internalMessage"
                    class="messagetexarea-text-color--warning fade-in"
                  ></div>
                </b-form-checkbox>
                <div v-if="message.isAgendado" class="datepicked-text">
                  <label>
                    {{ $t("sectionConversas.conversasMensagemAgendadaPara") }}
                    {{ message.data.toLocaleString() }}
                  </label>
                </div>
                <DateTimePicker
                  evento="send-scheduled"
                  @send-scheduled="onMessageDateScheduled"
                ></DateTimePicker>
                <ButtonEmoji evento="send-emoji" @send-emoji="sendEmoji" />
                <ModalRecord
                  :contato-id="talkSelected.contatoId"
                  :enumTipoContato = "talkSelected.enumTipoContato"
                  evento="send-file"
                  @send-file="sendFile"
                />
                <ModalFile
                  :contato-id="talkSelected.contatoId"
                  evento="send-file"
                  @send-file="sendFile"
                />

                <DefaultMessageBox
                  :talk-selected="talkSelected"
                  @onClickMessage="onClickDefalutMessage"
                />
                <ModeloMensagemBox
                  v-if="numeroOficial"
                  :contato-id="talkSelected.contatoId"
                  :telefoneId="telefoneIdSelected"
                  @send-modelo="sendModeloMensagem"
                />
              </div>
            </div>
            <div class="chat-footer-buttons-container">
              <AttendenceController
                v-if="
                  !talkSelected.isGrupo &&
                  !footerDisabledActions &&
                  $store.getters.getAutenticacao.isAtendente"
                  
                :title="$t('sectionConversas.textVisualizarOpcoes')"
                class="mt-1 mb-1"
                :contatoId="getContatoBudget()"
                :atendimentoId="getAttendanceBudget()"
                :tipo="getTipoAttendance()"
                :telefoneId="telefoneIdSelected"
                :enumTipoContato = "talkSelected.enumTipoContato"
                @endAttendence="showAttendenceButton"
                @startAttendence="hideAttendenceButton"
              />
              <ModalNewBudget
                v-if="
                  !talkSelected.isGrupo &&
                  !footerDisabledActions &&
                  $store.getters.getAutenticacao.isAtendente &&
                  permiteCriacaoOrcamento
                "
                class="mb-1"
                :contatoId="getContatoBudget()"
                :telefoneId="telefoneIdSelected"
                :atendimentoId="getAttendanceBudget()"
                :status="getStatusBudget()"
                :origem="getOrigemBudget(talkSelected.enumTipoContato)"
                :enumTipoContato = "talkSelected.enumTipoContato"
              />
              <ModalPayment
                v-if="
                  !talkSelected.isGrupo &&
                  !footerDisabledActions &&
                  $store.getters.getAutenticacao.isAtendente
                "
                :contatoId="getContatoBudget()"
                evento="sendPayLink"
                @sendPayLink="sendPayLink"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <SignalR
      ref="chatSignalR"
      :url="$store.getters.baseURL"
      :parametro="{
        contaId: $store.getters.getAutenticacao.contaSelecionadaId
      }"
      nomeEventoReceber="ReceberMensagem"
      nomeHub="chathub"
      nomeEventoRegistro="Registrar"
      nomeEventoEmit="on-message-received"
      nomeEventoReconnectEmit="on-reconnect-signarl"
      @on-message-received="onMessageReceived"
      @on-reconnect-signarl="onReconnectSignarl"
    />
  </div>
</template>

<style lang="scss">
@import "/scss/main.scss";
</style>

<script>
import {v4 as uuidv4} from "uuid"
import Message from "./Message"
import ButtonRefresh from "../../components/chat/ButtonRefresh.vue"
import MessageContainer from "./MessageContainer"
import MessageDetail from "./MessageDetail"
import AttendenceController from "../../components/sistema/AttendanceController"
import SignalR from "../../components/signalr/SignalR"
import TalkHeader from "./TalkHeader"
import DefaultMessageBox from "../../components/sistema/DefaultMessageBox"
import DefaultMessageBoxComand from "../../components/sistema/DefaultMessageBoxComand"
import ModeloMensagemBox from "../../components/sistema/ModeloMensagemBox"
import OrigemMensagem from "../../enums/OrigemMensagem"
import TipoMensagem from "../../enums/TipoMensagem" 
import TipoAtendimento from "../../enums/TipoAtendimento"
import DateTimePicker from "./DateTimePicker.vue"
import ModalArchive from "./ModalArchive"
import ModalFile from "../../components/sistema/ModalFile"
import ModalNewBudget from "./ModalNewBudget"
import OrigemOrcamento from "../../enums/OrigemOrcamento"
import StatusOrcamento from "../../enums/StatusOrcamento"
import ModalBudget from "./ModalBudget"
import ModalSearch from "./ModalSearch"
import ModalRecord from "./ModalRecord"
import ButtonEmoji from "./ButtonEmoji"
import ModalPerson from "./ModalPerson"
import ModalPayment from "../../components/sistema/ModalPayment"
import TipoChatHub from "../../enums/TipoChatHub"
import ModalTag from "../../components/sistema/ModalTag"
import {StatusAtendimento, DonoAtendimento} from "../../enums/StatusAtendimento"
import TagsContainer from "../../components/sistema/TagsContainer"
import IniciarAtendimento from "@/components/IniciarAtendimento.vue"
import ProfilePicture from "@/components/chat/ProfilePicture.vue"
import {cilOptionsHorizontal} from "@coreui/icons"

const donoAtendimento = () => {
  return DonoAtendimento
}
const statusAtendimento = () => {
  return StatusAtendimento
}
const tipoAtendimento = () => {
  return TipoAtendimento
}
const defaultMessage = () => {
  return {
    id: "",
    contaId: "", //
    telefoneId: "", //enviar com o telefone da empresa
    contatoId: "", //enviar quando o contato já existe (Vou receber do backend)
    telefoneContato: "", // Enviar somente quando for uma nova conversa
    nomeContato: "", //Enviar somente quanto for uma nova conversa
    corpo: "",
    isGrupo: false, // quando for uma nova conversa enviar como false
    data: "", // somente
    tipo: "",
    origem: "", // usado para renderizar corretamente a mensagem no front não vai o backend não utiliza.
    arquivoId: "",
    isAgendado: false,
    telefone: "",
    IdMensagemResposta:null
  }
}
const defaultPagingMessages = () => {
  return {
    loading: false,
    perPage: 0,
    totalPages: 0,
    page: 1
  }
}
const defaultPagingTalks = () => {
  return {
    loading: false,
    totalItens: 0,
    totalPages: 0,
    page: 1,
  }
} 

export default {
  name: "Chat",
  components: {
    TalkHeader,
    Message,
    MessageContainer,
    MessageDetail,
    DefaultMessageBox,
    DefaultMessageBoxComand,
    ModeloMensagemBox,
    ButtonRefresh,
    SignalR,
    AttendenceController,
    DateTimePicker,
    ModalArchive,
    ModalFile,
    ModalNewBudget,
    ModalBudget,
    ModalSearch,
    ModalRecord,
    ButtonEmoji,
    ModalPerson,
    ModalPayment,
    ModalTag,
    TagsContainer,
    IniciarAtendimento,
    ProfilePicture,
    CompanyPhone: () => import("@/components/chat/CompanyPhone.vue"),
    FilterMessages: () => import("@/components/chat/FilterMessages.vue")
  },
  data() {
    return {
      mostrarConteudo: false,
      MessageIndex:0,
      pesquisarMessageBoxComand: "",
      vSelectContato: [],
      thumbnailUrls: [],
      numeroOficial:false,
      podeMandarMsg:true,
      listAttendance: [],
      flagaba: 1,
      countNovo: 0,
      countEmAndamento: 0,
      chats: [],
      startAttendenceButtonVisibility: false,
      locale: this.$i18n.locale,
      attendance: {},
      internalMessage: false,
      scheduleMessageDate: "",
      chatTalksFilter: {
        ordem: 2,
        isSemAtendente: false,
        isNova: false
      },
      contaId: "",
      telefoneIdSelected: "",
      talkSelected: {},
      chatTalks: [],
      footerDisabledActions: false,
      pagingMessages: defaultPagingMessages(),
      pagingTalks: defaultPagingTalks(),
      messages: [],
      urlImagePefil: [],
      message: defaultMessage(),
      newPhone: "",
      FoneForUrl:  '',
      showInternalMessage: true,
      showLogMessage: false,
      loadingBuildMessage: false,
      parameter: {},
      permiteCriacaoOrcamento: false,
      loadingChatAll: false,
      chatTalksFiltered: {
        newCalls: {
          total: 0,
          data: [],
          load: false,
          page: 1,
          totalPages: 0
        },
        inAttendance: {
          total: 0,
          data: [],
          load: false,
          page: 1,
          totalPages: 0
        },
        callsCompleted: {
          total: 0,
          data: [],
          load: false,
          page: 1,
          totalPages: 0
        }
      },
      filtro: {
        contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        numero: "",
        pessoa: "",
        atendentes: null,
        etapas: null,
        status: 0,
        telefone: {},
        isNova: false,
        isSemAtendente: false,
        ordem: 1,
        periodoConversaInicial: "",
        periodoConversaFinal: ""
      },
      mensagemResponder:null,
      tipo:null
    }
  },
  computed: {
    TipoAtendimento: tipoAtendimento,
    StatusAtendimento: statusAtendimento,
    DonoAtendimento: donoAtendimento
  },
  watch: {
    locale(val) {
      this.$i18n.locale = val
    },
    showInternalMessage: function () {
      this.onClickConversation(this.talkSelected)
    },
    showLogMessage: function () {
      this.onClickConversation(this.talkSelected)
    }
  },
  beforeDestroy() {
    this.$refs.chatSignalR.Fechar()
  },
  mounted() {
    this.$refs.chatSignalR.Iniciar()
    this.getParameter()
    this.loadListOfAttendants()
    let id = this.$route.params.id;
    if (id) this.LocalizarConversaOrcamento(id);
  },
  methods: {
   async  funcAba(option) {
      this.flagaba = option
      switch (this.flagaba) {
        //this.chats retorna array de objetos das mensagens por aba
        case 1:
          this.chatTalksFilter.ordem = this.parameter.parametrizacaoContatosNovos
          this.chats = this.chatTalksFiltered.newCalls.data
          //this.ImageMinifyNewCalls(this.telefoneIdSelected)
          break
        case 2:  
            this.chatTalksFilter.ordem = this.parameter.parametrizacaoContatosAtendimento
          this.chats = this.chatTalksFiltered.inAttendance.data
          //this.ImageMinifyInAttendance(this.telefoneIdSelected)
          break
          case 3: 
            this.chatTalksFilter.ordem = this.parameter.parametrizacaoContatosConcluidos
            this.chats = this.chatTalksFiltered.callsCompleted.data
            //this.ImageMinifycallsCompleted(this.telefoneIdSelected)
            break
            default:
              this.chats = this.chatTalks
            }
    },
    async  funcAba2(option) {
      this.flagaba = option
      switch (this.flagaba) {
        //this.chats retorna array de objetos das mensagens por aba
        case 1:
        const filterNovo = this.handleFilterMessagesRequest(await this.filterNewCalls())
          if (this.chatTalksFilter.atendentes) {
            filterNovo.atendentes = null
            filterNovo.isSemAtendente = false
          }
          await this.getChatTalksByFilter(filterNovo)  
          this.chatTalksFilter.ordem = this.parameter.parametrizacaoContatosNovos
          this.chats = this.chatTalksFiltered.newCalls.data
          break
        case 2:
        const filterAtendimento = this.handleFilterMessagesRequest(this.filterInAttendance())
          await this.getChatTalksByFilter(filterAtendimento)     
            this.chatTalksFilter.ordem = this.parameter.parametrizacaoContatosAtendimento
          this.chats = this.chatTalksFiltered.inAttendance.data
          break
          case 3: 
          const filter = this.handleFilterMessagesRequest(this.filterCallsCompleted())
          await this.getChatTalksByFilter(filter)     
            this.chatTalksFilter.ordem = this.parameter.parametrizacaoContatosConcluidos
            this.chats = this.chatTalksFiltered.callsCompleted.data
            break
            default:
              this.chats = this.chatTalks
            }
    },
    showAttendenceButton() {
      this.startAttendenceButtonVisibility = true

      const firstPage = 1

      // for (let item of this.chatTalksFiltered.inAttendance.data) {
      //   if (item.atendimento == null) {
          this.talkSelected = {}
          this.clearChatTalksFiltered()
          this.getAllChatTalks(firstPage, "")
          this.funcAba(2)
      //   }
      // }
    },
    async hideAttendenceButton() {
      const firstPage = 1
      const onStatusModification = 2
      this.startAttendenceButtonVisibility = false
      //this.desabledBadge()
      this.desabledBadgeNewAttendance()

      for (let item of this.chatTalksFiltered.newCalls.data) {
        if (item.atendimento != null) {
          this.clearChatTalksFiltered()
          this.getAllChatTalks(firstPage, "")
          this.funcAba(onStatusModification)
        }
      }
      
    },
    async hideAttendenceButton2() {
      const onStatusModification = 2
      this.startAttendenceButtonVisibility = false
      //this.desabledBadge()
      this.desabledBadgeNewAttendance()
      this.funcAba(onStatusModification)  
    },
    addNewPhone(tipoContato) {
      if (!this.newPhone) {
        const validPhoneNumber = this.$t("infoMessages.validPhoneNumber")
        this.$notify({
          data: [validPhoneNumber],
          type: "warn",
          duration: 10000
        })
        return
      }
      let contatoVM = {
        ContaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        NumeroTelefone: this.newPhone,
        Nome: this.newPhone,
        EnumTipoContato:tipoContato,
        TelefoneId: this.telefoneIdSelected
      }
      let chatExistente = this.chatTalks.filter(
        (x) => x.numero === this.newPhone
      )
      this.$http({
        url: "contato/novo-para-conversa",
        data: contatoVM,
        method: "POST"
      })
        .then((resposta) => {
          this.newPhone = ""
          if (chatExistente[0] == undefined) {
            this.chatTalks.splice(0, 0, resposta.data)
          }
          this.onClickConversation(resposta.data)
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          })
        })
    },
    onMessageDateScheduled(e) {
      if (e) {
        this.internalMessage = false
        this.message.isAgendado = true
        this.message.data = e
      }
    },

    getMessageTextAreaClass() {
      if (this.internalMessage) {
        this.message.isAgendado = false
        return "message-text-area--internal"
      }
      if (this.message.isAgendado) {
        return "message-text-area--scheduled"
      }
      return ""
    },
    onAttendanceChange(signalRMessage) {
      if (
        this.getChatReady() && // verifica se o chat está ativo/inicializado
        this.talkSelected.contatoId === signalRMessage.contatoId //verifica se a conversa seleciona é a mesma aberta
      ) {
        //console.log("[onMessageReceived] Atualiza Atendimento");
        if (!signalRMessage) {
          //console.warn("Contato Null: ", signalRMessage);
        }
        this.talkSelected.atendimento = signalRMessage.atendimento

        this.attendance = signalRMessage.atendimento
        this.changeChat(this.getChatOwner())
        //console.log("Contatos: ", this.chatTalks);
      }
      this.validarCriacaoOrcamento()
    },
    onMessageReceived(e) {
      const camelCaseE = this.convertToCamelCase(e);
      //console.log("evento", camelCaseE)
      if (
        camelCaseE.contaId !== this.$store.getters.getAutenticacao.contaSelecionadaId //verifica se a msg é da conta selecionada
      ) {
        return // se não for a mesma sai fora
      }
      switch (camelCaseE.tipo) {
        case TipoChatHub.Mensagem:
          this.newMessageSignarl(camelCaseE.objeto)
          break
        case TipoChatHub.Atendimento:
          this.newAttendanceSignarl(camelCaseE.objeto)
          break
        case TipoChatHub.Etapa:
          this.newEtapaSignarl(camelCaseE.objeto)
          break
        default:
          break
      }
    },
    newEtapaSignarl(e) {   


      let emAtendimento = this.chatTalksFiltered.inAttendance.data.filter(x => x.contatoId === e.contatoId)
      let novoAtendimento = this.chatTalksFiltered.newCalls.data.filter(x => x.contatoId === e.contatoId) 
      let ConcluidoAtendimento = this.chatTalksFiltered.callsCompleted.data.filter(x => x.contatoId === e.contatoId)

      if (emAtendimento.length > 0) {
        emAtendimento[0].etapas = e.etapas
      } else if (novoAtendimento.length > 0) {
        novoAtendimento[0].etapas = e.etapas
      } else if (ConcluidoAtendimento.length > 0) {
        ConcluidoAtendimento[0].etapas = e.etapas
      }


    },
    newAttendanceSignarl(e) {
      if (!this.telefoneIdSelected) return
      this.onAttendanceChange(e)

      let emAtendimento = this.chatTalksFiltered.inAttendance.data.filter(x => x.contatoId === e.contatoId)
      let novoAtendimento = this.chatTalksFiltered.newCalls.data.filter(x => x.contatoId === e.contatoId)
      let ConcluidoAtendimento = this.chatTalksFiltered.callsCompleted.data.filter(x => x.contatoId === e.contatoId)
        if (novoAtendimento.length > 0) {
          // codigo a ser executado se a condicao1 for verdadeira
            novoAtendimento[0].atendimento = e.atendimento
            this.chatTalksFiltered.inAttendance.data.unshift(novoAtendimento[0])
            this.chatTalksFiltered.inAttendance.total += 1;

            let posicao = this.chatTalksFiltered.newCalls.data.indexOf(novoAtendimento[0])
            this.chatTalksFiltered.newCalls.data.splice(posicao,1)
            this.chatTalksFiltered.newCalls.total -= 1;
        } else if (emAtendimento.length > 0) {
          // codigo a ser executado se a condicao1 for falsa e a condicao2 for verdadeira
          console.log("e ematendimento", e)
            emAtendimento[0].atendimento = e.atendimento

            if(e.atendimento === null){
            let posicao = this.chatTalksFiltered.inAttendance.data.indexOf(emAtendimento[0])
            this.chatTalksFiltered.inAttendance.data.splice(posicao,1)
            this.chatTalksFiltered.inAttendance.total -= 1;
            this.chatTalksFiltered.callsCompleted.data.push(emAtendimento[0])
            }
        } else if (ConcluidoAtendimento.length > 0) {
          // codigo a ser executado se as condicoes1 e 2 forem falsas e a condicao3 for verdadeira
             ConcluidoAtendimento[0].atendimento = e.atendimento
            this.chatTalksFiltered.inAttendance.data.unshift(ConcluidoAtendimento[0])
            this.chatTalksFiltered.inAttendance.total += 1;
            let posicao = this.chatTalksFiltered.callsCompleted.data.indexOf(ConcluidoAtendimento[0])
            this.chatTalksFiltered.callsCompleted.data.splice(posicao,1)
        } else if (e.atendimento === null) {
          this.chatTalksFiltered.inAttendance.total -= 1;
        }else{
          // codigo a ser executado se as condicoes1, 2 e 3 forem falsas
            this.chatTalksFiltered.inAttendance.data.unshift(e)
            this.chatTalksFiltered.inAttendance.total += 1;
        }

    },
    newMessageSignarl(e) {
      if (this.telefoneIdSelected !== e.telefoneId) return
      if (
        this.getChatReady() && // verifica se o chat está ativo/inicializado
        this.talkSelected.contatoId === e.contato.contatoId //verifica se a conversa seleciona é  a mesma aberta
      ) {
        // verifica se a mensagem já não está incluída)
        let msgEditar = this.messages.filter((x) => x.id === e.id)
        if (msgEditar <= 0) {
          let vm = this
          this.messages.push(e)
          setTimeout(() => {
            vm.setScrollToBottom()
          }, 1000)
        } else {
          //caso a mensagem ja exista na conversa, alteramos o status dela

          msgEditar[0].status = e.status
          msgEditar[0].excluido = e.excluido
          msgEditar[0].isEditado = e.isEditado
          msgEditar[0].corpo = e.corpo
          msgEditar[0].ultimaReacao = e.ultimaReacao

        }
      } else {
        // não é a mesma conversa aberta, então atualizar lista de conversa com badge
      let emAtendimento = this.chatTalksFiltered.inAttendance.data.filter(x => x.contatoId === e.contato.contatoId)
      let novoAtendimento = this.chatTalksFiltered.newCalls.data.filter(x => x.contatoId === e.contato.contatoId)
      let ConcluidoAtendimento = this.chatTalksFiltered.callsCompleted.data.filter(x => x.contatoId === e.contato.contatoId)

        if (novoAtendimento.length > 0 && e.origem == 1) {
          // codigo a ser executado se a condicao1 for verdadeira
          this.attSignalRNewMsg(novoAtendimento[0],e)
        } else if (emAtendimento.length > 0 && e.origem == 1) {
          // codigo a ser executado se a condicao1 for falsa e a condicao2 for verdadeira
          this.attSignalRNewMsg(emAtendimento[0],e)
        } else if (ConcluidoAtendimento.length > 0 && e.origem == 1) {
          // codigo a ser executado se as condicoes1 e 2 forem falsas e a condicao3 for verdadeira
          this.chatTalksFiltered.newCalls.data.unshift(ConcluidoAtendimento[0])
          this.chatTalksFiltered.newCalls.total += 1;

          let posicao = this.chatTalksFiltered.callsCompleted.data.indexOf(ConcluidoAtendimento[0])
          this.chatTalksFiltered.callsCompleted.data.splice(posicao,1)

          this.attSignalRNewMsg(ConcluidoAtendimento[0],e)

        } else if (e.contato.atendimento == null && e.origem == 1) {
            this.chatTalksFiltered.newCalls.data.unshift(e.contato)
            this.chatTalksFiltered.newCalls.total += 1;
        } 

      }
      if ("Notification" in window && e.origem === OrigemMensagem.Recebida) {
        //nojo isso! porra faz um método!
        if (Notification.permission === "granted") {
          new Notification(e.contato.nome + ": " + e.corpo)
        } else if (Notification.permission !== "denied") {
          Notification.requestPermission().then(function (permission) {
            if (permission === "granted") {
              new Notification(e.contato.nome + ": " + e.corpo)
            }
          })
        }
      }
    },
    async attSignalRNewMsg(talk,e){

              talk.badge = e.contato.badge
              talk.nome = e.contato.nome
              talk.contatoId = e.contato.contatoId
              talk.dataUltimoProcessamento = e.contato.dataUltimoProcessamento
              talk.isGrupo = e.contato.isGrupo
              talk.numero = e.contato.numero
              talk.prazoRespostaExpirado = e.contato.prazoRespostaExpirado
    },
    getChatOwner() {
      if (
        this.attendance &&
        this.attendance.usuarioId ==
          this.$store.getters.getAutenticacao.usuarioId // verifica se o usuário que está atendendo
      ) {

        return DonoAtendimento.Dono
      } else if (this.attendance && Object.keys(this.attendance).length) {

        return DonoAtendimento.EmAtendimento
      } else {

        return DonoAtendimento.AguardandoAtendimento
      }
    },
    validarCriacaoOrcamento() {
      this.permiteCriacaoOrcamento = false
      if (!this.parameter.obrigarAtendimentoOrcamento) {
        this.permiteCriacaoOrcamento = true
      } else {
        this.permiteCriacaoOrcamento =
          this.talkSelected.atendimento != undefined
      }
    },
    changeChat(owner) {
      if (!this.parameter.bloquearAtendimento)
        this.footerDisabledActions = false
      else {
        if (this.$store.getters.getAutenticacao.perfil === 2)
          this.footerDisabledActions = false
        else {
          switch (owner) {
            case DonoAtendimento.Dono:
              this.footerDisabledActions = false
              break
            case DonoAtendimento.EmAtendimento:
              this.footerDisabledActions = true
              break
            case DonoAtendimento.AguardandoAtendimento:
              this.footerDisabledActions = false
              break
            default:
              break
          }
        }
      }
      this.validarCriacaoOrcamento()
    },
    onClickDefalutMessage(e) {
        this.message.corpo += " " + e.texto
    },
    replaceComando(){
      if (this.message.corpo.includes('/')) {
      // Encontrar a posição do primeiro espaço em branco após a '/'
      const indexEspaco = this.message.corpo.indexOf(' ', this.message.corpo.indexOf('/') + 1);

      // Verificar se encontrou um espaço em branco após a '/'
      if (indexEspaco !== -1) {
        // Substituir o conteúdo entre '/' e o primeiro espaço em branco por vazio
        this.message.corpo = this.message.corpo.substring(0, this.message.corpo.indexOf('/')) + this.message.corpo.substring(indexEspaco + 1);
      }
    }
      this.MessageIndex = 0;
    },
    async onKeyUpTextAreaMessage(e) {
      if(e.keyCode == 13 && this.contemComandoTextArea()){
        this.replaceComando()
        return;
      }

      if (e.keyCode == 13 && !e.shiftKey) {
        e.preventDefault()
        if (!this.talkSelected.atendimento && !this.talkSelected.isGrupo) {
          if (!(this.message.isAgendado && this.$store.getters.getAutenticacao.atendimentoMsgAgendada)) {
            this.startAtendimento();
            this.funcAba(2);
          }
        }
        //new
        this.desabledBadgeNewAttendance()


        if (
          !this.talkSelected.isGrupo &&
          !this.footerDisabledActions &&
          this.$store.getters.getAutenticacao.isAtendente == false
        ) {
          this.startAttendenceButtonVisibility = false
        }
        
          if(this.thumbnailUrls.length > 0){
            this.enviarImagemCopiada(this.thumbnailUrls);
            this.thumbnailUrls = [];
          }
        this.buildMessage()
      }
    },
    async enviarImagemCopiada(imagensClipboard){


       imagensClipboard.forEach( async element => {
          let vm = {
            contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
            nome:element.fileName,
            mimeType: element.fileType,
            base64:element.url.split('base64,')[1]
          }

          this.$http({
              url: "midia/conversa",
              method: "POST",
              data: vm
            })
              .then((response) => {
                console.log("resposta",response.data)
                
                this.sendFile(response.data)
              })
              .catch((err) => {
                this.$notify({
                  data: err.response.data.erros,
                  type: "warn",
                  duration: 10000
                })
              })
            });

    },
    async startAtendimento() {
      let vm = {
        contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        contatoId: this.getContatoBudget(),
        tipo: this.getTipoAttendance(),
        TipoContato: this.talkSelected.enumTipoContato,
        telefoneId: this.telefoneIdSelected,
      }
      this.$http({
        url: "atendimento/iniciar",
        method: "POST",
        data: vm
      })
        .then(() => {
          this.desabledBadgeNewAttendance()
          //this.desabledBadge()
          this.hideAttendenceButton()
          
          const serviceStartedSuccessfully = this.$t(
            "infoMessages.serviceStartedSuccessfully"
          )

          this.$notify({
            data: [serviceStartedSuccessfully],
            type: "success",
            duration: 3000
          })
          !this.buttonIniciarAtendimento()
        })
        .catch((err) => {
          this.$notify({
            data: err.response.data.erros,
            type: "warn",
            duration: 10000
          })
        })
    },
    desabledBadgeNewAttendance() {
      this.chatTalksFiltered.newCalls.data =
        this.chatTalksFiltered.newCalls.data.map((talk) => {
          if (talk.contatoId === this.talkSelected.contatoId) {
            talk.badge = false
          }
          return talk
        })
    },
    desabledBadgeInAttendance() {
      this.chatTalksFiltered.inAttendance.data =
      this.chatTalksFiltered.inAttendance.data.map((talk) => {
        if (talk.contatoId === this.talkSelected.contatoId) {
          talk.badge = false
        }
        return talk
      })
    },
    
    async onSelectAccountPhoneNumber(filter, typeRequest) {
      try {
        this.loadingChatAll = true
        this.clearChatTalksFiltered()
        this.chatTalksFilter = filter
        if (typeRequest !== "FILTER_MESSAGES") {
          if (this.flagaba == 1) {
            this.chatTalksFilter.ordem = this.parameter.parametrizacaoContatosNovos
               
          } else if (this.flagaba == 2) {
            this.chatTalksFilter.ordem = this.parameter.parametrizacaoContatosAtendimento
           // this.ImageMinifyInAttendance(this.telefoneIdSelected)
          } else if (this.flagaba == 3) {
            this.chatTalksFilter.ordem = this.parameter.parametrizacaoContatosConcluidos
          }
        }
        this.$store.commit('telefoneSelecionado/SET_FILTER', this.chatTalksFilter.telefone);
        
        this.numeroOficial = this.chatTalksFilter.telefone.numeroOficial;
        this.pagingMessages = defaultPagingMessages()
        this.pagingTalks = defaultPagingTalks()
        this.chatTalks = []
        this.messages = []
        this.talkSelected = {}
        this.message = defaultMessage()
        this.telefoneIdSelected = filter.telefone.id
        //this.getChatTalks(this.pagingTalks.page)
        this.chatTalks = []
        this.chats = []
        
        const firstPage = 1
        await this.getAllChatTalks(firstPage, typeRequest)
        this.funcAba(this.flagaba)

        await this.delay(1000)
        
        
        
        this.hideAttendenceButton()
        
    
      } finally {
        this.loadingChatAll = false
        
      }
    },
    onReconnectSignarl() {
      const internetConnectionReestablished = this.$t(
        "infoMessages.internetConnectionReestablished"
      )
      const loadMessages = this.$t("infoMessages.loadMessages")
      this.$notify({
        data: [internetConnectionReestablished, loadMessages],
        type: "warn",
        duration: 5000
      })
      //this.onSelectAccountPhoneNumber(this.chatTalksFilter)
    },
    async onClickConversation(e) {
      const {atendimento = {}} = e
      if (!atendimento) this.startAttendenceButtonVisibility = true
      if (atendimento && atendimento.status != StatusAtendimento.EmAtendimento)
        this.startAttendenceButtonVisibility = true

      if (atendimento && atendimento.status === StatusAtendimento.EmAtendimento)
        this.startAttendenceButtonVisibility = false
      this.messages = []
      this.message = defaultMessage()
      this.mensagemResponder = null;
      this.mostrarConteudo = false;
      this.MessageIndex = 0;
      this.pesquisarMessageBoxComand="";
      this.pagingMessages = defaultPagingMessages()
      this.talkSelected = e

      let idUsuarioAtendimento = this.talkSelected.atendimento
        ? this.talkSelected.atendimento.usuarioId
        : this.talkSelected.atendimento
      let idUsuarioLogado = this.$store.getters.getUsuarioId

      if (
        atendimento &&
        atendimento.status === StatusAtendimento.EmAtendimento &&
        idUsuarioAtendimento === idUsuarioLogado
      ) {
        //this.desabledBadge()
        this.desabledBadgeInAttendance()
      }

      if (this.talkSelected.isGrupo) {
        this.startAttendenceButtonVisibility = false
      }

      this.pagingMessages.loading = !this.pagingMessages.loading
      this.messages = await this.getMessagesFromTalk(this.pagingMessages.page)
      this.pagingMessages.loading = !this.pagingMessages.loading
      this.attendance = this.talkSelected.atendimento
      this.changeChat(this.getChatOwner())
      this.setScrollToBottom()
      this.$refs.textAreaMessageElement.focus();
    },
    async onScrollChatTalksContainer() {
      var chatTalksContainer = document.getElementById("ChatTalksContainer")
      let height = chatTalksContainer.scrollHeight
      let offset = chatTalksContainer.offsetHeight
      let scrollTop = chatTalksContainer.scrollTop
      if (height - offset * 0.2 <= scrollTop + offset) {
        this.onScrollGetChatTalks()
      }
    },
    async onScrollChatListContainer() {
      var chatTalksContainer = document.getElementById("ChatListContainer");
      let previousScrollHeight = chatTalksContainer.scrollHeight;

      if (chatTalksContainer.scrollTop === 0) {
        await this.onScrollGetMessagesFromTalk();

        // Calculate the difference in scroll height due to new messages
        let scrollHeightDifference = chatTalksContainer.scrollHeight - previousScrollHeight;

        // Adjust the scroll position to maintain the same position
        chatTalksContainer.scrollTop = scrollHeightDifference;
      }
    },
    setScrollToBottom() {
      //console.log("[setScrollToBottom]");
      var element = document.getElementById("ChatListContainer")
      if (element.scrollHeight == element.clientHeight) {
        //console.log("[setScrollToBottom]: sem scroll");
        return
      }
      element.scrollTo({top: element.scrollHeight - 15, behavior: "auto"})
      element.scrollTo({top: element.scrollHeight, behavior: "smooth"})
     
    },
    async buildMessage(e) {
      if (!this.message.corpo.trim() || this.loadingBuildMessage) {
        return
      }
      try {
        this.loadingBuildMessage = true
        if (!this.message.data) this.message.data = new Date()
        this.message.id = uuidv4()
        this.message.nomeContato = this.$store.getters.getAutenticacao.apelido
        this.message.contaId =
        this.$store.getters.getAutenticacao.contaSelecionadaId
        this.message.telefoneId = this.telefoneIdSelected
        this.message.telefone = this.chatTalksFilter.telefone.label
        this.message.contatoId = this.talkSelected.contatoId
        this.message.isGrupo = false
        this.message.tipo = this.getMessageType()
        this.message.origem = 2
        this.message.tipoContato = this.talkSelected.enumTipoContato
        let name = this.$store.getters.getAutenticacao.apelido
        if (name) {
          name = name[0].toUpperCase() + name.slice(1)
        }
        if(this.mensagemResponder){
          this.message.idMensagemResposta = this.mensagemResponder.id;
        }
        
        this.afterBuildMessage()
        await this.sendMessage()
        this.setScrollToBottom()
        this.$refs.textAreaMessageElement.focus()
      } catch (error) {
        let array = JSON.parse(localStorage.getItem("P.ArrayLog"))
        if (!array) array = []
        array.push(
          "Erro ao enviar mensagem: " +
            error +
            " Data: " +
            new Date().toLocaleString()
        )
        localStorage.setItem("P.ArrayLog", JSON.stringify(array))
      } finally {
        this.loadingBuildMessage = false
      }
    },
    async buildMessageAnexo(e) {
      if (!this.message.corpo.trim() ) {
        return
      }
      try {
        this.loadingBuildMessage = true
        if (!this.message.data) this.message.data = new Date()
        this.message.id = uuidv4()
        this.message.nomeContato = this.$store.getters.getAutenticacao.apelido
        this.message.contaId =
        this.$store.getters.getAutenticacao.contaSelecionadaId
        this.message.telefoneId = this.telefoneIdSelected
        this.message.telefone = this.chatTalksFilter.telefone.label
        this.message.contatoId = this.talkSelected.contatoId
        this.message.isGrupo = false
        this.message.tipo = this.getMessageType()
        this.message.origem = 2
        this.message.tipoContato = this.talkSelected.enumTipoContato
        let name = this.$store.getters.getAutenticacao.apelido
        if (name) {
          name = name[0].toUpperCase() + name.slice(1)
        }
        
        if(this.mensagemResponder){
          this.message.idMensagemResposta = this.mensagemResponder.id;
        }
        this.afterBuildMessage()
        await this.sendMessage()
        this.setScrollToBottom()
        this.$refs.textAreaMessageElement.focus()
      } catch (error) {
        let array = JSON.parse(localStorage.getItem("P.ArrayLog"))
        if (!array) array = []
        array.push(
          "Erro ao enviar mensagem: " +
            error +
            " Data: " +
            new Date().toLocaleString()
        )
        localStorage.setItem("P.ArrayLog", JSON.stringify(array))
      } finally {
        this.loadingBuildMessage = false
      }
    },
    afterBuildMessage() {
      this.internalMessage = false
    },
    getCurrentTalkAttendance() {
      if (
        !this.getChatReady() ||
        !this.talkSelected.atendimento ||
        this.talkSelected.isGrupo
      ) {
        return {}
      }
      return this.talkSelected.atendimento
    },
    getChatReady() {
      if (
        this.telefoneIdSelected &&
        this.talkSelected &&
        this.talkSelected.contatoId
      ) {
        return true
      }
      return false
    },
    getMessageType() {
      if (this.internalMessage) return TipoMensagem.Interna
      if (!this.message.tipo) return TipoMensagem.Texto
      return this.message.tipo
    },
    async sendFile(file) {
      if (!file) return
      if (!this.talkSelected.atendimento && !this.talkSelected.isGrupo){
          this.startAtendimento() 
          this.funcAba(2)
        }
      this.message.corpo = file.descricao
      this.message.arquivoId = file.arquivoId
      this.message.tipo = file.tipo
      await this.buildMessageAnexo()
    },
    async sendModeloMensagem() {
      if (!this.talkSelected.atendimento && !this.talkSelected.isGrupo){
          this.startAtendimento() 
          this.funcAba(2)
        }
    },
    async onScrollGetMessagesFromTalk() {
      if (
        this.pagingMessages.loading ||
        this.pagingMessages.totalPages === this.pagingMessages.page
      ) {

        return
      }
      this.pagingMessages.loading = !this.pagingMessages.loading
      var itens = await this.getMessagesFromTalk(this.pagingMessages.page + 1)
      this.pagingMessages.loading = !this.pagingMessages.loading

    },
    async getMessagesFromTalk(pageNumber) {
      return await this.$http({
        url:
          "mensagem-front/obter?ContaId=" +
          this.$store.getters.getAutenticacao.contaSelecionadaId +
          "&TelefoneId=" +
          this.telefoneIdSelected +
          "&ContatoId=" +
          this.talkSelected.contatoId +
          "&Pagina=" +
          pageNumber +
          "&Log=" +
          this.showLogMessage +
          "&Interno=" +
          this.showInternalMessage+
          "&TipoConversa=" +
          this.talkSelected.enumTipoContato,
        method: "GET"
      })
        .then((response) => {
          this.pagingMessages.page = pageNumber
          this.pagingMessages.totalPages = response.data.totalDePaginas
          this.pagingMessages.perPage = response.data.itens.length - 1
          this.messages.splice(0, 0, ...response.data.itens)
          this.podeMandarMsg = response.data.itens.length ? response.data.itens[0].podeMandarMsg : this.talkSelected.enumTipoContato === 3 ? false :true
          
          return response.data.itens
        })
        .catch((err) => {
          this.$notify({
            data: err.response.data.erros,
            type: "warn",
            duration: 10000
          })
        })
    },
    // Obter todos os atendimentos já categorizados
    async getAllChatTalks(pageNumber, typeRequest) {

      this.chatTalksFilter.pagina = pageNumber
      this.delayToUpdateChatTalks = 1000 // Aumentar o delay entre requisições

      // Carregar os filtros dos três tipos de colunas: Novo, Em Atendimento e Concluído
      const filtersChatTalks = [
        this.filterNewCalls,
        this.filterInAttendance
      ]
      // this.clearChatTalksFiltered()
      for (let index = 0; index < filtersChatTalks.length; ++index) {
        const filterChatTalk = filtersChatTalks[index]()
        let filter = {}

        if (typeRequest === "FILTER_MESSAGES") {
          //this.clearChatTalksFiltered()
          filter = this.handleFilterMessagesRequest(filterChatTalk)

          } else {
            filter = {...this.chatTalksFilter, ...filterChatTalk}
        }
        await this.getChatTalksByFilter(filter)
        //await this.delay(this.delayToUpdateChatTalks)
        //this.ImageMinifyInAttendance(this.telefoneIdSelected)
        //this.ImageMinifyNewCalls(this.telefoneIdSelected)

      }
      // this.setSuccessUpdatedDate()
    },
    // Tratar Chat Talks Filter caso requisição seja feita pelo filtro
    handleFilterMessagesRequest(filterChatTalk) {
      if (this.chatTalksFilter.atendentes && this.chatTalksFilter.atendentes.length > 0) {
        filterChatTalk.atendentes = this.chatTalksFilter.atendentes
        filterChatTalk.isSemAtendente = false

        // this.clearChatTalksFiltered()
        return {...this.chatTalksFilter, ...filterChatTalk}
      } else {
        return {...this.chatTalksFilter, ...filterChatTalk}
      }
    },
    // Carregar lista de atendentes - Essa lista é utilizada para obter todas as conversas 'Em Atendimento'
    loadListOfAttendants() {
      this.$http({
        url:
          "/usuario/obter-select2-atendente/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId,
        method: "GET"
      })
        .then((response) => {
          this.listAttendance = response.data
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          })
        })
    },
    // Delay utilizado para atrasar algumas requisições, pois o back atualmente não suporta multiplas requisições; sendo limitado com erro (geralmente erro 503)
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    // Obter Atendimentos filtrados
    // increment() {
    //   this.componentKey++;
    //     },
   async  getChatTalksByFilter(filter) {
      //console.log(filter)
     await this.$http({
        url: "mensagem-front/obter-conversas",
        data: filter,
        method: "POST"
      })
        .then(async (response) => {
            const data = response.data
            
            const totalChat = data.total
            const totalPages = data.totalDePaginas
            const chatTalks = []
            
            chatTalks.push(...data.itens)
            
            const result = {
              totalChat,
              totalPages,
              chatTalks
            }
            //this.clearChatTalksFiltered()
            // Mecanismo para popular os arrays de acordo com o filtro aplicado
            // console.log("result", result)
            // console.log("filter", filter)
 
              this.setChatTalksFiltered(result, filter)     
              setTimeout(()=>{
              //this.ImageMinify(filter.telefone.id)

            },5000)        
        })
        .catch((err) => {
          console.warn("Erro ao retornar Conversas do chat: ", err)
          this.$notify({
            data: err.response.data.erros,
            type: "warn",
            duration: 10000
          })

          this.updatedHoursChatTalks = `${this.$t(
            "sectionKanban.notUpdatedAt"
          )}`
        })
    },
    // Popular colunas de acordo com o filtro
    setChatTalksFiltered(chatTalksFiltered, appliedFilter) {
      const {totalChat = 0, totalPages = 0, chatTalks = []} = chatTalksFiltered

      const isItNewService =
        appliedFilter.isNova && appliedFilter.isSemAtendente // || 
      // (appliedFilter.isNova && !appliedFilter.atendentes.length) 
      //console.log("isItNewService", isItNewService)

      if (isItNewService ) {
        this.chatTalksFiltered.newCalls.data.push(
          ...this.handleResultChatTalks(
            this.chatTalksFiltered.newCalls.data,
            chatTalks
          )
        )
        this.chatTalksFiltered.newCalls.total = totalChat
        this.chatTalksFiltered.newCalls.totalPages = totalPages
        this.chatTalksFiltered.newCalls.load = false

        if(appliedFilter.pagina > 1)
        setTimeout(() => {
          this.funcAba(1); 
        },0)
        // //Ordenar coluna por período
        // this.orderNewCalls()
      }

      // Verifica se tipo de filtro aplicado é para retornar 'Novo' atendimento
      const inAttendance =
        appliedFilter.atendentes &&
        !appliedFilter.isSemAtendente &&
        appliedFilter.atendentes.length

      //  console.log("inAttendance", inAttendance)
      if (inAttendance) {
        this.chatTalksFiltered.inAttendance.data.push(
          ...this.handleResultChatTalks(
            this.chatTalksFiltered.inAttendance.data,
            chatTalks
          )
        )
        this.chatTalksFiltered.inAttendance.total = totalChat
        this.chatTalksFiltered.inAttendance.totalPages = totalPages
        this.chatTalksFiltered.inAttendance.load = false

        if(appliedFilter.pagina > 1)this.funcAba(2); 
        // //Ordenar coluna por período
        // this.orderInAttendance()
      }

      const serviceCompleted =
        (!appliedFilter.isNova && appliedFilter.isSemAtendente) ||
        !(appliedFilter.atendentes && appliedFilter.atendentes.length)

      //  console.log("serviceCompleted", serviceCompleted)
        if (serviceCompleted) {
          const removedPendentChat = chatTalks.filter(
            (chatTalk) => chatTalk.badge === false
            )
            this.chatTalksFiltered.callsCompleted.data.push(
              ...this.handleResultChatTalks(
                this.chatTalksFiltered.callsCompleted.data,
                removedPendentChat
                )
                )
                
                if (this.chatTalksFiltered.callsCompleted.data.length) {
                  this.chatTalksFiltered.callsCompleted.total = totalChat
                  this.chatTalksFiltered.callsCompleted.totalPages = totalPages
               }
                
        this.chatTalksFiltered.callsCompleted.load = false

      }
    },

    //Verifica se existe item na lista e filtra remove caso exista
    handleResultChatTalks(chatTalksFiltered = [], chatTalks = []) {
      return chatTalks.filter(
        (chat) =>
          !chatTalksFiltered.find(
            (chatFiltered) => chatFiltered.contatoId === chat.contatoId
          )
      )
    },

    // Carregar apenas atendimentos 'Novos'
    async getNewChatTalks() {
      if (
        this.chatTalksFiltered.newCalls.load ||
        this.chatTalksFiltered.newCalls.page ===
          this.chatTalksFiltered.newCalls.totalPages
      ) {
        return
      }

      this.updatedHoursChatTalks = this.$t("sectionKanban.wait")
      this.delayToUpdateChatTalks = 1000

      const numberPage = this.chatTalksFiltered.newCalls.totalPages

      this.chatTalksFiltered.newCalls.load = true
      this.chatTalksFiltered.newCalls.page =
        this.chatTalksFiltered.newCalls.page + 1
      this.chatTalksFilter.pagina = this.chatTalksFiltered.newCalls.page
      await this.delay(this.delayToUpdateChatTalks)
      const filter = this.handleFilterMessagesRequest(await this.filterNewCalls())

      if (this.chatTalksFilter.atendentes) {
        filter.atendentes = null
        filter.isSemAtendente = false
      }

        await  this.getChatTalksByFilter(filter)

      if (!this.chatTalksFiltered.newCalls.totalPages) {
        this.chatTalksFiltered.newCalls.totalPages = numberPage
      }
      // this.setSuccessUpdatedDate()
    },

    // Carregar apenas atendimentos 'Em atendimento'
    async getInAttendanceChatTalks() {
      setTimeout(()=> {
      if (
        this.chatTalksFiltered.inAttendance.load ||
        this.chatTalksFiltered.inAttendance.page ===
          this.chatTalksFiltered.inAttendance.totalPages
      ) {
        return
      }

      this.updatedHoursChatTalks = this.$t("sectionKanban.wait")
      //this.delayToUpdateChatTalks = 1000

      const numberPage = this.chatTalksFiltered.inAttendance.totalPages

      this.chatTalksFiltered.inAttendance.load = true
      this.chatTalksFiltered.inAttendance.page =
        this.chatTalksFiltered.inAttendance.page + 1

      this.chatTalksFilter.pagina = this.chatTalksFiltered.inAttendance.page
      //await this.delay(this.delayToUpdateChatTalks)

      const filter = this.handleFilterMessagesRequest(this.filterInAttendance())
      this.getChatTalksByFilter(filter)

      if (!this.chatTalksFiltered.inAttendance.totalPages) {
        this.chatTalksFiltered.inAttendance.totalPages = numberPage
      }
    },1000)
      // this.setSuccessUpdatedDate()
    },

    // Carregar apenas atendimentos 'Concluído'
    async getCallsChatTalks() {
      if (
        this.chatTalksFiltered.callsCompleted.load ||
        this.chatTalksFiltered.callsCompleted.page ===
          this.chatTalksFiltered.callsCompleted.totalPages
      ) {
        return
      }

      this.updatedHoursChatTalks = this.$t("sectionKanban.wait")
      this.delayToUpdateChatTalks = 1000

      const numberPage = this.chatTalksFiltered.inAttendance.totalPages

      this.chatTalksFiltered.callsCompleted.load = true
      this.chatTalksFiltered.callsCompleted.page =
        this.chatTalksFiltered.callsCompleted.page + 1
      this.chatTalksFilter.pagina = this.chatTalksFiltered.callsCompleted.page
      await this.delay(this.delayToUpdateChatTalks)
      const filter = this.handleFilterMessagesRequest(
        this.filterCallsCompleted()
      )
      await this.getChatTalksByFilter(filter)

      if (!this.chatTalksFiltered.inAttendance.totalPages) {
        this.chatTalksFiltered.inAttendance.totalPages = numberPage
      }
      
    },
    async onScrollGetChatTalks() {
      switch (this.flagaba) {
        case 1:
             await this.getNewChatTalks(this.chatTalksFiltered.newCalls.page + 1)
          break
        case 2:
          await this.getInAttendanceChatTalks(
            this.chatTalksFiltered.inAttendance.page + 1
          )
          break
        case 3:
          await this.getCallsChatTalks(
            this.chatTalksFiltered.callsCompleted.page + 1
          )
          break
      }
    },

    // Resetar as colunas
    clearChatTalksFiltered() {
      this.chatTalksFiltered = {
        newCalls: {
          total: 0,
          data: [],
          load: false,
          page: 1,
          totalPages: 0,
        },
        inAttendance: {
          total: 0,
          data: [],
          load: false,
          page: 1,
          totalPages: 0
        },
        callsCompleted: {
          total: 0,
          data: [],
          load: false,
          page: 1,
          totalPages: 0
        }
      }
    },
    // Ordernar coluna de 'Novo Atendimento'
    orderNewCalls(isDesc = true) {
      let arrayOrder = []

      if (isDesc) {
        arrayOrder = this.chatTalksFiltered.newCalls.data.sort(
          (a, b) =>
            Number(new Date(a.dataUltimoProcessamento)) -
            Number(new Date(b.dataUltimoProcessamento))
        )
      } else {
        arrayOrder = this.chatTalksFiltered.newCalls.data.sort(
          (a, b) =>
            Number(new Date(b.dataUltimoProcessamento)) -
            Number(new Date(a.dataUltimoProcessamento))
        )
      }

      this.chatTalksFiltered.newCalls.data = arrayOrder
    },

    // Ordernar coluna de 'Em Atendimento'
    orderInAttendance(isDesc = true) {
      let arrayOrder = []

      if (isDesc) {
        arrayOrder = this.chatTalksFiltered.inAttendance.data.sort(
          (a, b) =>
            Number(new Date(a.dataUltimoProcessamento)) -
            Number(new Date(b.dataUltimoProcessamento))
        )
      } else {
        arrayOrder = this.chatTalksFiltered.inAttendance.data.sort(
          (a, b) =>
            Number(new Date(b.dataUltimoProcessamento)) -
            Number(new Date(a.dataUltimoProcessamento))
        )
      }

      this.chatTalksFiltered.inAttendance.data = arrayOrder
    },

    // Ordernar coluna de 'Concluido'
    orderCallsCompleted(isDesc = true) {
      let arrayOrder = []

      if (isDesc) {
        arrayOrder = this.chatTalksFiltered.callsCompleted.data.sort(
          (a, b) =>
            Number(new Date(a.dataUltimoProcessamento)) -
            Number(new Date(b.dataUltimoProcessamento))
        )
      } else {
        arrayOrder = this.chatTalksFiltered.callsCompleted.data.sort(
          (a, b) =>
            Number(new Date(b.dataUltimoProcessamento)) -
            Number(new Date(a.dataUltimoProcessamento))
        )
      }

      this.chatTalksFiltered.callsCompleted.data = arrayOrder
    },

    // Filtro utilizado para obter somente conversas 'Novas'
    filterNewCalls() {
        return {
          ...this.chatTalksFilter,
          isNova: true,
          isSemAtendente: true,
          ordem: this.parameter.parametrizacaoContatosNovos
        }

    },

    // Filtro utilizado para obter somente conversas 'Em Atendimento'
    filterInAttendance() {
        return {
          ...this.chatTalksFilter,
          atendentes: this.listAttendance,
          ordem: this.parameter.parametrizacaoContatosAtendimento
        }

    },
    // Filtro utilizado para obter somente conversas 'Concluídas'
    filterCallsCompleted() {
        return {
          ...this.chatTalksFilter,
          isSemAtendente: true, 
          ordem: this.parameter.parametrizacaoContatosConcluidos
        }

    },
    getCountBadge() {
      if (!this.chatTalks) return 0
      return this.chatTalks.filter((x) => x.badge).length
    },
    async sendMessage() {
      return this.$http({
        url: "mensagem-front/receber",
        data: this.message,
        method: "POST"
      })
        .then((response) => {

          this.message = defaultMessage()
          this.mensagemResponder = null;
        })
        .catch((err) => {

          this.$notify({
            data: [err.response.data],
            type: "warn",
            duration: 10000
          })
        })
    },
    getContatoBudget() {
      return this.talkSelected && this.talkSelected.contatoId
        ? this.talkSelected.contatoId
        : null
    },
    getAttendanceBudget() {
      return this.talkSelected &&
        this.talkSelected.atendimento &&
        this.talkSelected.atendimento.id
        ? this.talkSelected.atendimento.id
        : null
    },
    getStatusBudget() {
      return StatusOrcamento.Pendente
    },
    getOrigemBudget(tipoConversa) {
      switch (tipoConversa) {
        case 0:
          return OrigemOrcamento.WhatsApp 
        case 1:
        return OrigemOrcamento.Instagram 
        case 2:
        return OrigemOrcamento.Messenger
        case 3:
        return OrigemOrcamento.WhatsAppOficial
        default:
          break;
      }
      
    },
    getTipoAttendance() {
      return TipoAtendimento.WhatsApp
    },
    sendEmoji(emoji) {
      this.message.corpo += emoji
    },
    setPedencyTalkSelected() {
      if (!this.talkSelected || !this.talkSelected.contatoId) {
        const contactNotFound = this.$t("infoMessages.contactNotFound")
        this.$notify({
          data: [contactNotFound],
          type: "warn",
          duration: 10000
        })
        return
      }
      this.$http({
        url: "contato/marcar-pendente/" + this.talkSelected.contatoId,
        method: "GET"
      })
        .then(() => {
          this.talkSelected.isPendente = !this.talkSelected.isPendente
        })
        .catch((err) => {
          this.$notify({
            data: err.response.data.erros,
            type: "warn",
            duration: 10000
          })
        })
    },
    getPlaceHolderNewPhone() {
      if (
        this.chatTalksFilter &&
        this.chatTalksFilter.telefone &&
        this.chatTalksFilter.telefone.label
      )
        return (
          "Ex: " + this.chatTalksFilter.telefone.label.substring(0, 4) + "..."
        )
      else return "Novo telefone"
    },
    getUserAttendance(atendimento) {
      if (!atendimento || !atendimento.usuarioNome) return ""
      let split = atendimento.usuarioNome.split("@")
      if (split.length > 0) return split[0]
      else return atendimento.usuarioNome
    },
    updateTalkSelected(talk) {
      if (!talk) return
      this.talkSelected.nome = talk.nome
      this.talkSelected.numero = talk.numeroTelefone
    },
    sendPayLink(link) {
      if (!link) return
      this.message.corpo = link
    },
    getEtapas() {
      if (!this.talkSelected || !this.talkSelected.etapas) return []
      return this.talkSelected.etapas
    },
    updateEtapas(etapas) {
      if (!this.talkSelected) return
      this.talkSelected.etapas = etapas
    },
    getTitleEtapas(etapas) {
      if (!etapas) return ""
      let b = etapas.map((x) => x.descricao)
      b.join(", ")
      return "Etapa(s): " + b
    },
    getParameter() {
      this.$http({
        url:
          "parametro/obter/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId,
        method: "GET"
      })
        .then((response) => {
          this.parameter = response.data
        })
        .catch((err) => {
          this.$notify({
            data: err.response.data.erros,
            type: "warn",
            duration: 10000
          })
        })
    },
    getDateFormat(data) {
      if (!data) return ""

      let d = new Date(data)
      let hora = d.toLocaleTimeString().split(":")
      let horaFormatada = hora[0] + ":" + hora[1]
      if (d.toLocaleDateString() === new Date().toLocaleDateString())
        return "Hoje " + horaFormatada
      else return d.toLocaleDateString() + " " + horaFormatada
    },
    onPaste(event) {
      const items = event.clipboardData.items;

      if (this.thumbnailUrls.length >= 5) {
        this.$notify({
          data: [ this.$t("textLimitArquivos") ],
          type: "warn",
          duration: 10000
        })
        return;
      }

      
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const blob = item.getAsFile();

            // Verifica se o tamanho do arquivo é maior que 5MB
          if (blob.size > 5 * 1024 * 1024) {
            this.$notify({
              data: [ this.$t("sectionModalFile.topFileSize5mb") ],
              type: "warn",
              duration: 10000
            })
            return;
          }

        const fileName = blob.name;
        const fileType = blob.type;
        const reader = new FileReader();
        reader.onload = (event) => {
          // Adiciona a miniatura ao array
          this.thumbnailUrls.push({
            url: event.target.result,
            fileType: fileType,
            icon: this.getIconByType(fileType),
            fileName: fileName
          });
        };

        reader.readAsDataURL(blob);
      }
    },
    removeThumbnail(index) {
      this.thumbnailUrls.splice(index, 1);
    },
    getIconByType(fileType) {
      switch (fileType) {
        case 'image/png':
        case 'image/jpeg':
          return 'image-icon.png';
        case 'application/pdf':
          return 'pdfIcon50px.png';
        case 'text/plain':
          return 'text-icon.png';
        // Adicione outros tipos de arquivos e ícones aqui
        default:
          return 'default-icon.png';
      }
    },
    replyMessage(mensagemParaResponder){
      console.log("resp ",mensagemParaResponder)
      this.$refs.textAreaMessageElement.focus();
      this.mensagemResponder = mensagemParaResponder;

    },
    removeMsgResponder(){
      this.mensagemResponder = null;
    },
    ObterContato(val) {
      if (!val || val.length <= 3) return

      this.$http({
        url:
          "contato/obter-select2-telefone/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId +
          "/" + this.numeroOficial +
          "/" +
          val,
        method: "GET"
      })
        .then((resposta) => {
          if (resposta.data && resposta.data.length > 0)
            this.vSelectContato = resposta.data
          else {
            const novaOpcao = { id: "", label: val };

        // Adicione a nova opção ao vSelectContato
            this.vSelectContato = [novaOpcao];
          }
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          })
        })
    },
    handleSelectItem(selectedItem) {
      //selectedItem.label = selectedItem.label.replace(/[^0-9]/g, '');
      if (selectedItem.label.includes(' -')) {
        const partes = selectedItem.label.split(' -');
        const numeroSelecionado = partes[0].trim();
        const apenasNumero = numeroSelecionado.replace(/[^0-9]/g, '')
        this.newPhone = apenasNumero;
      }else{
        const numeroSelecionado = selectedItem.label.replace(/[^0-9]/g, '');
        this.newPhone = numeroSelecionado;
      }
        this.addNewPhone(!this.numeroOficial? 0 : 3);
        this.vSelectContato= [];
    },
    LocalizarConversaOrcamento(orcamentoId) {
      this.$http({
        url: "orcamento/obter/" + orcamentoId,
        method: "GET"
      })
        .then((resposta) => {
          setTimeout(() => {
          if(resposta.data.contato.numeroTelefone){
            this.newPhone = resposta.data.contato.numeroTelefone;
            this.addNewPhone(resposta.data.contato.enumTipoContato);
          }
        }, 500);
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    onInputTextAreaMessage(event) {
      const inputValue = event.target.value;

      // Verifique se o texto começa com '/' para buscar as mensagens padrão
      if (inputValue.startsWith('/')) {
        const partes = inputValue.split('/');
        const buscar = partes[1];
        this.MessageIndex = 0;
        this.mostrarConteudo = true;
        this.pesquisarMessageBoxComand = buscar;
      }else
      this.mostrarConteudo = false;
    },
    contemComandoTextArea(){
      const inputValue = this.message.corpo
      // Verifique se o texto começa com '/' para buscar as mensagens padrão
      if (inputValue.startsWith('/'))
        return true;
      else
        return false; 

    },
    onKeyDownTextAreaMessage(event) {
      if (event.keyCode === 38 && this.contemComandoTextArea()) {
        // Tecla para cima pressionada
        console.log("Seta para cima pressionada");
        this.MessageIndex--;
      } else if (event.keyCode === 40 && this.contemComandoTextArea()) {
        // Tecla para baixo pressionada
        console.log("Seta para baixo pressionada");
        this.MessageIndex++;
      }
    },
    convertToCamelCase(obj) {
      if (typeof obj !== 'object' || obj === null) {
        return obj;
      }
      if (Array.isArray(obj)) {
        return obj.map(item =>  this.convertToCamelCase(item));
      }
      const camelCaseObj = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const camelCaseKey = key.charAt(0).toLowerCase() + key.slice(1);
          camelCaseObj[camelCaseKey] = this.convertToCamelCase(obj[key]);
        }
      }
      return camelCaseObj;
    }
  }
}
</script>

<style scoped>
.aviso {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  background-color: #ffdddd;
  color: #f00;
  white-space: nowrap;
}
.respondendoMsg {
  position: absolute;
  top: 0px;
  left: 2%;
  padding: 8px;
  background-color: #128C7E;
  border-radius: 15px;
  color: #01201d;
  max-width: 92%;
  transform: translateY(-90%);
}
.remove-respondendoMsg-button {
    position: absolute;
    right: 2%;
    top: -0.5rem;
    width: 20px;
    height: 20px;
    font-size: 12px;
    color: white;
    background-color: rgba(255, 0, 0, 0.5);
    border: none;
    border-radius: 50%;
    cursor: pointer;
  }
.btn-align {
  margin-top: 15px;
  margin-left: 8px;
  display: flex;
}

.container__selected {
  display: flex;
  justify-content: space-between;
  margin-right: 8px;
}
.thumbnails-container {
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  top: -5rem;
  margin-left: 10px;
}

.thumbnail-container {
  display: flex;
  flex-direction: column;
  width: 100px;
  height: 100px;
  margin-right: 10px;
  margin-bottom: 10px;

}

.thumbnail {
  max-width: 80px;
  max-height: 80px;
  object-fit: cover;
}

.thumbnail-icon{
  max-width: 60px;
  max-height: 60px;
  object-fit: cover;
}
.remove-thumbnail-button {
    position: absolute;
    margin-left: 5rem;
    width: 20px;
    height: 20px;
    font-size: 12px;
    color: white;
    background-color: rgba(255, 0, 0, 0.5);
    border: none;
    border-radius: 50%;
    cursor: pointer;
  }
</style>
